<template>
  <aside class="js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered">
    <div class="navbar-vertical-container">
      <div class="navbar-vertical-footer-offset">
        <div class="navbar-brand-wrapper justify-content-between">
          <!-- Logo -->
          <a class="navbar-brand" href="/" aria-label="Front">
            <img class="navbar-brand-logo" src="/images/cashouse_logo.png" alt="Logo" />
            <img class="navbar-brand-logo-mini" src="/images/cashouse_logo_mobile_icon.png" alt="Logo" />
          </a>
          <!-- End Logo -->

          <!-- Navbar Vertical Toggle -->
          <button type="button" class="js-navbar-vertical-aside-toggle-invoker navbar-vertical-aside-toggle btn btn-icon btn-xs btn-ghost-dark">
            <i class="tio-clear tio-lg"></i>
          </button>
          <!-- End Navbar Vertical Toggle -->
        </div>

        <!-- Content -->
        <div class="navbar-vertical-content">
          <ul class="navbar-nav navbar-nav-lg nav-tabs">
            <li class="nav-item">
              <small class="nav-subtitle" title="Pages">Immobili</small>
              <small class="tio-more-horizontal nav-subtitle-replacer"></small>
            </li>

            <li class="nav-item">
              <a class="js-nav-tooltip-link nav-link active" :href="route('dashboard')" title="Referrals" data-placement="left">
                <i class="tio-dashboard nav-icon"></i>
                <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Instant deal value</span>
              </a>
            </li>

            <!-- <li class="nav-item">
              <a class="js-nav-tooltip-link nav-link active" :href="route('properties.index')" title="Referrals" data-placement="left">
                <i class="tio-dashboard nav-icon"></i>
                <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Zona attiva</span>
              </a>
            </li> -->

            <!-- <li class="nav-item">
              <a class="js-nav-tooltip-link nav-link active" :href="route('properties.out_of_zone')" title="Referrals" data-placement="left">
                <i class="tio-dashboard nav-icon"></i>
                <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Fuori zona</span>
              </a>
            </li> -->

            <li class="nav-item">
              <a class="js-nav-tooltip-link nav-link active" :href="route('properties.deal')" title="Referrals" data-placement="left">
                <i class="tio-dashboard nav-icon"></i>
                <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Progetti</span>
              </a>
            </li>

            <li class="nav-item">
              <a class="js-nav-tooltip-link nav-link active" :href="route('properties.lead')" title="Referrals" data-placement="left">
                <i class="tio-dashboard nav-icon"></i>
                <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Lead</span>
              </a>
            </li>

            <template v-if="can.admin">
              <li class="nav-item">
                <small class="nav-subtitle" title="Pages">Impostazioni</small>
                <small class="tio-more-horizontal nav-subtitle-replacer"></small>
              </li>
              <li class="nav-item">
                <a class="js-nav-tooltip-link nav-link active" :href="route('municipalities.index')" title="Layouts" data-placement="left">
                  <i class="tio-dashboard nav-icon"></i>
                  <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Comuni</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="js-nav-tooltip-link nav-link active" :href="route('agencies.index')" title="Layouts" data-placement="left">
                  <i class="tio-dashboard nav-icon"></i>
                  <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Partner</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="js-nav-tooltip-link nav-link active" :href="route('users.index')" title="Layouts" data-placement="left">
                  <i class="tio-dashboard nav-icon"></i>
                  <span class="navbar-vertical-aside-mini-mode-hidden-elements text-truncate">Utenti</span>
                </a>
              </li>
            </template>
          </ul>
        </div>
        <!-- End Content -->
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: ["can"],
  mounted() {
    var sidebar = $(".js-navbar-vertical-aside").hsSideNav();
  }
};
</script>
